var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComboBundleGrayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2633 13.4228L20.7763 8.36639C21.8725 7.62861 21.8725 6.17139 20.7763 5.43359L13.2633 0.377124C12.5161 -0.125708 11.4808 -0.125708 10.7336 0.377124L3.22062 5.43359C2.12438 6.17139 2.12438 7.62861 3.22062 8.36639L10.7336 13.4228C11.4808 13.9257 12.5161 13.9257 13.2633 13.4228Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4636 10.9923C20.8509 10.7317 21.3878 10.7317 21.775 10.9925C22.3427 11.3747 22.3427 12.1293 21.775 12.5116L13.3229 18.2026C12.5421 18.7283 11.4595 18.7283 10.6787 18.2026L2.2266 12.5116C1.65884 12.1293 1.65884 11.3747 2.2266 10.9925C2.27501 10.9599 2.32575 10.9314 2.37824 10.907C2.74571 10.7358 3.19908 10.7643 3.53802 10.9923L12.0008 16.6859L20.4636 10.9923Z",
    fill: "#808080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4636 15.7969C20.8509 15.5363 21.3878 15.5364 21.775 15.7972C22.3427 16.1794 22.3427 16.934 21.775 17.3163L13.3229 23.0073C12.5421 23.533 11.4595 23.533 10.6787 23.0073L2.2266 17.3163C1.65884 16.934 1.65884 16.1794 2.2266 15.7972C2.27501 15.7646 2.32575 15.7361 2.37824 15.7116C2.74571 15.5405 3.19908 15.569 3.53802 15.7969L12.0008 21.4906L20.4636 15.7969Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComboBundleGrayIcon);
export default __webpack_public_path__ + "static/media/combo-bundle-gray-icon.8d8097bce292e0e95130ef3a0d0f9416.svg";
export { ForwardRef as ReactComponent };